import React, { useEffect, useState } from 'react';
import './Modal.css';
import { useStore } from '../../Context';
import Modal from 'styled-react-modal';

const StyledModal = Modal.styled`
  width: 40ch;
  max-height: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  background-color: var(--color-background);
  padding: 1rem;
  margin-inline: 1rem;
`;

function ModalComponent({ children }) {
  const { isModalOpen, closeModal } = useStore();

  const [opacity, setOpacity] = useState(0);

  const originalModal = document.getElementById('customModal') || {};

  let timer1 = () => setTimeout(() => {
    originalModal.className = originalModal?.className?.replace(' shake', '');
  }, 300);

  const handleCloseModal = (e) => {
    if (children.length) {
      const modalProps = children[0]?.props?.modal;
      // shake effect
      if(modalProps.backdrop === 'static') {
        originalModal.className = `${originalModal.className} shake`;
        return timer1();
      }
    }

    setOpacity(0);
    closeModal();
  };

  const afterOpen = () => {
    setTimeout(() => {
      setOpacity(1);
    }, 100);
  };

  const beforeClose = () => {
    return new Promise((resolve) => {
      setOpacity(0);
      setTimeout(resolve, 300);
    });
  };

  // Use Effect
  useEffect(
    () => {
      return () => {
        clearTimeout(timer1);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <StyledModal
      isOpen={isModalOpen}
      afterOpen={afterOpen}
      beforeClose={beforeClose}
      onBackgroundClick={handleCloseModal}
      onEscapeKeydown={handleCloseModal}
      opacity={opacity}
      backgroundProps={{ opacity }}
      id={children[0]?.props?.id}
    >
      {children}
    </StyledModal>
  );
}

export default ModalComponent;
